<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getDepartmentAllList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        orgIdsOptions: [],
        form: [
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          { // 月份
            label: '月份',
            value: 'yearMonth',
            type: 'date',
            placeholder: '请选择月份',
            attr: {
              type: 'monthrange',
            },
          },
          { // 线路名称
            label: '线路名称',
            value: 'lineName',
            type: 'input',
            placeholder: '请输入线路名称',
          },
          { // 归属部门
            label: '归属部门',
            value: 'orgIds',
            type: 'select',
            multiple: true,
            placeholder: '请输入归属部门',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      if (searchBoxData.yearMonth && searchBoxData.yearMonth.length) {
        searchBoxData.yearMonBegin = this.formatDate(searchBoxData.yearMonth[0]);
        searchBoxData.yearMonEnd = this.formatDate(searchBoxData.yearMonth[1]);
        delete searchBoxData.yearMonth;
      }
      if (searchBoxData.orgIds && searchBoxData.orgIds.length) {
        searchBoxData.orgIds = searchBoxData.orgIds.join(',');
      }
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    this.searchBoxData.orgIdsOptions = [
      { label: '全部', value: -1 },
      ...((await getDepartmentAllList()) || []),
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
